export default __webpack_public_path__ + "static/media/support.3896c311.png";